import axios from "axios";
import { API } from "@/App";

export async function persistUserPreferences(patch) {
  await axios.patch(`${API}/auth/preferences`, patch);
}
